/* Rorilio · PDP Paño Rorilio XXL : barra de anuncio rotativa, galería, paquetes 2+1 / 3+3 / 8+4 (1 variante, cantidad N ; códigos de palier y regalos
   reales los pone el motor rorilio-offers.js), opción Guante (producto aparte a su precio), acordeones, videos de clientes. Sin temporizador (la fuente no tiene). */
(function () {
  if (window.__panoPdp) return; window.__panoPdp = true;
  function $a(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    /* Barra de anuncio */
    $a('[data-pn-rotate]').forEach(function (bar) {
      var msgs = $a('.pn-bar__msg', bar), i = 0, t = (parseInt(bar.getAttribute('data-pn-rotate'), 10) || 4) * 1000;
      if (msgs.length > 1) setInterval(function () { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, t);
    });
    /* Galería */
    $a('[data-pn-gal]').forEach(function (g) {
      var sl = g.querySelector('.pn-gal__slides'), th = $a('.pn-gal__thumb', g), dots = $a('.pn-gal__dots span', g), n = $a('.pn-gal__slide', g).length, cur = 0;
      function mark(i) { cur = i; th.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        var a = th[i]; if (a && a.parentNode.scrollTo) a.parentNode.scrollTo({ left: a.offsetLeft - a.parentNode.clientWidth / 2 + a.clientWidth / 2, behavior: 'smooth' }); }
      function go(i) { i = (i + n) % n; sl.scrollTo({ left: sl.clientWidth * i, behavior: 'smooth' }); mark(i); }
      th.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      $a('.pn-gal__nav', g).forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-dir'), 10)); }); });
      var w; sl.addEventListener('scroll', function () { clearTimeout(w); w = setTimeout(function () { var k = Math.round(sl.scrollLeft / (sl.clientWidth || 1)); if (k !== cur) mark(k); }, 90); }, { passive: true });
    });
    /* Compra */
    $a('[data-pn-buy]').forEach(function (b) {
      var packs = $a('[data-pack]', b), sel = b.querySelector('[data-pack].is-on') || packs[0], atc = b.querySelector('[data-atc]'), err = b.querySelector('[data-err]');
      var main = b.closest('.pn-main'), now = main && main.querySelector('[data-pn-now]'), was = main && main.querySelector('[data-pn-was]'), save = main && main.querySelector('[data-pn-save]');
      var glove = b.querySelector('[data-pn-glove]');
      function paint() {
        packs.forEach(function (p) { var on = p === sel; p.classList.toggle('is-on', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); });
        if (now) now.textContent = sel.getAttribute('data-price'); if (was) was.textContent = sel.getAttribute('data-was'); if (save) save.textContent = sel.getAttribute('data-save');
      }
      packs.forEach(function (p) {
        p.addEventListener('click', function () { if (sel !== p) { sel = p; paint(); } });
        p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sel = p; paint(); } });
      });
      function fail(e) { atc.classList.remove('is-busy'); if (err) { err.textContent = (e && e.message) || 'Error'; err.hidden = false; } }
      if (atc) atc.addEventListener('click', function () {
        var items = [{ id: Number(b.getAttribute('data-variant')), quantity: parseInt(sel.getAttribute('data-qty'), 10) || 1 }];
        if (glove && glove.checked && b.getAttribute('data-glove')) items.push({ id: Number(b.getAttribute('data-glove')), quantity: 1 });
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', RO = window.RorilioOffers;
        atc.classList.add('is-busy'); if (err) err.hidden = true;
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Error'); return j; }); })
          .then(function () { return RO ? RO.reconcile(true) : null; })
          .then(function (st) { atc.classList.remove('is-busy'); if (st) delete st._silent; if (!RO || !st || !st.sections || !RO.open(st)) location.href = root + 'cart'; })
          .catch(fail);
      });
      paint();
    });
    /* Acordeones */
    $a('[data-pn-acc]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var q = e.target.closest('[data-q]'); if (!q || !list.contains(q)) return;
        var it = q.parentElement, open = it.classList.contains('is-open');
        it.classList.toggle('is-open', !open); q.setAttribute('aria-expanded', open ? 'false' : 'true');
        var a = it.querySelector('[data-a]'); if (a) a.hidden = open;
      });
    });
    /* Videos de clientes */
    var vids = $a('[data-pn-vid]');
    vids.forEach(function (box) {
      var v = box.querySelector('video');
      box.querySelector('.pn-vid__play').addEventListener('click', function () {
        vids.forEach(function (o) { if (o !== box) { o.querySelector('video').pause(); o.classList.remove('is-playing'); o.querySelector('video').controls = false; } });
        box.classList.add('is-playing'); v.controls = true; v.play();
      });
      v.addEventListener('ended', function () { box.classList.remove('is-playing'); v.controls = false; });
    });
  });
})();
